import React from 'react';

interface RecordingTimerProps {
    duration: number;
    maxDuration?: number;
}

const RecordingTimer: React.FC<RecordingTimerProps> = ({ duration, maxDuration = 30 }) => {
    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    return (
        <div style={{ 
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px'
        }}>
            <div 
                style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    backgroundColor: '#EF4444',
                    animation: 'pulse 1.5s ease-in-out infinite'
                }}
            />
            <div style={{ 
                fontSize: '32px', 
                fontWeight: '600', 
                color: '#1E293B',
                fontVariantNumeric: 'tabular-nums',
                whiteSpace: 'nowrap',
                letterSpacing: '-0.5px'
            }}>
                {formatTime(duration)} <span style={{ color: '#94A3B8', fontSize: '24px', fontWeight: '400' }}>/ {formatTime(maxDuration)}</span>
            </div>
            
            <style>
                {`
                    @keyframes pulse {
                        0%, 100% {
                            opacity: 1;
                            transform: scale(1);
                        }
                        50% {
                            opacity: 0.5;
                            transform: scale(0.9);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default RecordingTimer;

